import { gql } from "@apollo/client";

export const MANUFACTURERS_QUERY = gql`
   query MasterManufacturers {
    masterManufacturers {
        id
        name
    }
}
`;

// Vendors Query

export const VENDORS_QUERY = gql`
  query MasterVendors {
    masterVendors {
        id
        company_name
        website
        email
        name
        phone_number
        country_code
        vendor_type
        can_login
        invited_by_user
        created_at
        updated_at
    }
}
`;

export const WORKORDER_STAGES_QUERY = gql`query MasterWorkOrderStages {
    masterWorkOrderStages {
        id
        name
        color_code
        is_default
        display_order
        created_at
        updated_at
    }
}
`;

// Work Orders  Query

export const MASTER_LOCATION_TYPES_QUERY = gql`
    query MasterLocationTypes {
        masterLocationTypes {
            id
            name
            allowedParents
            allowedParentsNames
            description
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Get Assets by Location ID Query

export const PRODUCTS_QUERY = gql`
  query Products($categoryId: ID, $typeId: ID, $manufacturerId: ID, $requested: Boolean) {
    products(categoryId: $categoryId, typeId: $typeId, manufacturerId: $manufacturerId, requested: $requested) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      status
      series
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
      createdAt
      updatedAt
      deletedAt
      parent {
        id
        parentId
        categoryId
        typeId
        manufacturerId
        successorId
        predecessorId
        name
        make
        model
        serialNumber
        dataSheets
        lifespan
        rating
        specifications
        images
        description
        lifecycleStatus
        manufacturerStatus
        isActive
        createdAt
        updatedAt
        deletedAt
      }
      children {
        id
        parentId
        categoryId
        typeId
        manufacturerId
        successorId
        predecessorId
        name
        make
        model
        serialNumber
        dataSheets
        lifespan
        rating
        specifications
        images
        description
        lifecycleStatus
        manufacturerStatus
        isActive
        createdAt
        updatedAt
        deletedAt
      }
      category {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      type {
        id
        categoryId
        parentId
        name
        description
        fieldDefinitions
        isActive
        iconName
        iconType
        iconColor
        createdAt
        updatedAt
        deletedAt
      }
      manufacturer {
        id
        name
      }
    }
  }
`;

export const PRODUCT_SERVICE_TYPES_QUERY = gql`
  query ProductServiceTypes {
    productServiceTypes {
      id
      name
      productCategoryIds
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const PRODUCTS_IDNAME_QUERY = gql`
  query Products($categoryId: ID, $typeId: ID, $manufacturerId: ID, $requested: Boolean) {
    products(categoryId: $categoryId, typeId: $typeId, manufacturerId: $manufacturerId, requested: $requested) {
      id
      name
      manufacturerId
      manufacturer {
        id
        name
      }
      categoryId
      category {
        id
        name
      }
      typeId
      type {
        id
        name
        fieldDefinitions
      }
      specifications
       children {
        id
        name
      }
    }
  }
`;

export const SIMPLE_PRODUCTS_QUERY = gql`
  query Products($categoryId: ID, $typeId: ID, $manufacturerId: ID, $requested: Boolean) {
    products(categoryId: $categoryId, typeId: $typeId, manufacturerId: $manufacturerId, requested: $requested) {
      id
      name
      category {
        id
        name
      }
      type {
        id
        name
      }
    }
  }
`;
// Asset Categories Query

export const PODUCT_CATEGORIES_QUERY = gql`
 query ProductCategories {
    productCategories {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
        parent {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
            createdAt
            updatedAt
            deletedAt
        }
        children {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
            createdAt
            updatedAt
            deletedAt
        }
    }
}
`;

export const PODUCT_CATEGORIES_QUERY_NAME = gql`
 query ProductCategories {
    productCategories {
        id
        name
    }
}
`;

export const PRODUCT_TYPES_QUERY_NAME = gql`query ProductTypes($categoryId: ID) {
  productTypes(categoryId: $categoryId) {
      id
      categoryId
      name
  }
}
`;

// Asset Types Query

export const PRODUCT_TYPES_QUERY = gql`query ProductTypes($categoryId: ID) {
  productTypes(categoryId: $categoryId) {
      id
      categoryId
      parentId
      name
      description
      fieldDefinitions
      isActive
      iconName
      iconType
      iconColor
      createdAt
      updatedAt
      deletedAt
      category {
          id
          parentId
          name
          description
          isActive
          iconName
          iconColor
          iconType
          createdAt
          updatedAt
          deletedAt
      }
  }
}
`;

export const GET_PRODUCT_TYPE_QUERY = gql`
  query GetProductType($id: ID!) {
    productType(id: $id) {
      id
      name
      fieldDefinitions
    }
  }
`;

// Master Data Requests Query

// Tickets Query

export const MASTER_DOCUMENT_TYPES_QUERY = gql`
  query MasterDocumentTypes {
    masterDocumentTypes {
      id
      type
      description
    }
  }
`;
